import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal-leave-team",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "modal-leave-team-title",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_3 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "modal-content",
        onKeydown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.leaveTeamApplyShortcut && _ctx.leaveTeamApplyShortcut(...args)))
      }, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "modal-body" }, [
          _createElementVNode("div", { class: "d-flex align-items-center" }, [
            _createElementVNode("i", { class: "fa fa-exclamation-circle fa-3x" }),
            _createElementVNode("p", { class: "m-0 ml-2" }, "You are going to leave the team. You will have to contact team owner if you decide to get back.")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _cache[2] || (_cache[2] = _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary btn-cancel",
            "data-dismiss": "modal",
            tabindex: "1"
          }, "Cancel", -1)),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-danger",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.leaveTeam && _ctx.leaveTeam(...args))),
            tabindex: "2"
          }, "Yes, leave this team")
        ])
      ], 32)
    ])
  ]))
}